/**
 * Protocol between the chat composer and the API's dictation socket. Binary
 * frames carry the microphone as PCM16 mono 24 kHz, the format of the spoken
 * practice; text frames carry these JSON events.
 */
export type DictationClientEvent =
  /** The user is done talking: end the turn and answer with what was said. */
  { type: 'stop' };

/**
 * `text` is everything said, trimmed, and empty when nothing was. The socket
 * closes after either event.
 */
export type DictationServerEvent =
  | { type: 'text'; text: string }
  | { type: 'error'; message: string };

export const DICTATION_PATH = '/voice/dictation';

/** Close code: this caller may not dictate (impersonated, expired or scoped). */
export const DICTATION_NOT_ALLOWED_CLOSE_CODE = 4403;
/** Close code: the same user started a newer dictation. */
export const DICTATION_REPLACED_CLOSE_CODE = 4409;
